import { ThemeBrandColors } from "../../types";

export const SpikevaxBrand: ThemeBrandColors = {
  "color-brand-50": "#F5F8FA",
  "color-brand-100": "#EAF1F4",
  "color-brand-200": "#D0E1E7",
  "color-brand-300": "#B9D3DC",
  "color-brand-400": "#76A9BA",
  "color-brand-500": "#558FA2",
  "color-brand-600": "#427487",
  "color-brand-700": "#365E6E",
  "color-brand-800": "#30505C",
  "color-brand-900": "#2C444E",
  "color-brand-950": "#1D2D34"
};
